export default function () {
    return {
        device: null,
        noJs: true,
        block: false,
        platform: null,
    };
}
